/* import __COLOCATED_TEMPLATE__ from './tour.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();